import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'sameDay'
})
export class SameDayPipe implements PipeTransform {

  transform(date1: number | Date | string, date2: number | Date | string): boolean {
    if (!date1 || !date2) {
      return false;
    }

    return this.sameDay(new Date(date1), new Date(date2));
  }

  sameDay(d1: Date, d2: Date): boolean {
    return d1.getFullYear() === d2.getFullYear()
      && d1.getMonth() === d2.getMonth()
      && d1.getDate() === d2.getDate();
  }
}
